import { Component, OnInit } from '@angular/core';
import { SocketService } from '../../layout/service/socket.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputOtpModule } from 'primeng/inputotp';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { UserService } from '../../layout/service/user.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Router } from '@angular/router';
import { PaginatorModule } from 'primeng/paginator';

@Component({
    selector: 'app-simulation',
    imports: [FormsModule, CommonModule, InputOtpModule, ButtonModule, InputTextModule, ProgressSpinnerModule, PaginatorModule],
    styles: [
        `
            .auth-container {
                display: block;
                border-radius: 1.25rem;
                background: linear-gradient(to right, #5B8EEE, #4DC8DF);
                padding: 2rem;
            }
            .auth-card {
                max-width: 100%;
                padding: 2.5rem 2rem 2rem 2rem;
                border-radius: 1.25rem;
                box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
                background: rgba(255, 255, 255, 0.1);;
                justify-content: center;
                text-align: center;
                margin: 0 auto;
                transition: box-shadow 0.2s;
            }
            .auth-card-participants {
                max-width: 100%;
                min-height: 100%;
                max-height: 100vh;
                width: 100%;
                padding: 2.5rem 2rem 2rem 2rem;
                border-radius: 1.25rem;
                box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
                background: rgba(255, 255, 255, 0.1);
                justify-content: center;
                text-align: center;
                margin: 0 auto;
                transition: box-shadow 0.2s;
                overflow-y: auto;
            }
            .auth-card:focus-within {
                box-shadow: 0 12px 40px 0 rgba(31, 38, 135, 0.22);
            }
            .auth-title {
                color: white;
                font-size: 2rem;
                font-weight: 700;
                margin-bottom: 2rem;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 0.5rem;
            }
            .auth-desc {
                color: #64748b;
                margin-bottom: 2rem;
                text-align: center;
                font-size: 1rem;
            }
            .otp-input {
                margin-bottom: 1.5rem;
            }
            .otp-input ::ng-deep .p-inputotp-input {
                background: rgba(0, 0, 0, 0.05) !important;
                border: 2px solid white !important;
                color: white !important;
                border-radius: 8px !important;
                font-weight: 600 !important;
                font-size: 1.2rem !important;
                text-align: center !important;
                backdrop-filter: blur(5px) !important;
                transition: all 0.3s ease !important;
            }
            .otp-input ::ng-deep .p-inputotp-input:focus {
                border-color: rgba(255, 255, 255, 0.8) !important;
                box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2) !important;
                background: rgba(0, 0, 0, 0.1) !important;
            }
            .otp-input ::ng-deep .p-inputotp-input::placeholder {
                color: rgba(255, 255, 255, 0.6) !important;
            }
            .name-input-container {
                margin-bottom: 1.5rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 0.5rem;
            }
            .name-input-label {
                color: white;
                font-size: 1rem;
                font-weight: 600;
                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
            }
            .name-input {
                background: rgba(0, 0, 0, 0.05) !important;
                border: 2px solid white !important;
                color: white !important;
                border-radius: 8px !important;
                font-weight: 600 !important;
                font-size: 1rem !important;
                padding: 0.75rem 1rem !important;
                backdrop-filter: blur(5px) !important;
                transition: all 0.3s ease !important;
                max-width: 340px;
                width: 100%;
            }
            .name-input:focus {
                border-color: rgba(255, 255, 255, 0.8) !important;
                box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2) !important;
                background: rgba(0, 0, 0, 0.1) !important;
                outline: none !important;
            }
            .name-input::placeholder {
                color: rgba(255, 255, 255, 0.6) !important;
            }
            .submit-btn {
                width: 100%;
                max-width: 340px;
                font-weight: 600;
                font-size: 1.1rem;
                border-radius: 8px;
                height: 2.75rem;
                padding: 0 1.5rem;
                background: #0371B2 !important;
                border: 2px solid #0371B2 !important;
                color: white !important;
                transition: all 0.3s ease !important;
            }
            .submit-btn:hover:not(:disabled) {
                background: #025a8f !important;
                border-color: #025a8f !important;
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(3, 113, 178, 0.3) !important;
            }
            .submit-btn:disabled {
                background: rgba(255, 255, 255, 0.3) !important;
                border-color: rgba(255, 255, 255, 0.3) !important;
                color: rgba(255, 255, 255, 0.6) !important;
            }
            .feedback {
                margin-top: 1.25rem;
                font-size: 1rem;
                text-align: center;
                min-height: 1.5rem;
            }
            .feedback.success {
                color: #22c55e;
            }
            .feedback.error {
                color: #ef4444;
            }
            .loading-spinner {
                margin-left: 0.5rem;
                border: 2px solid #2563eb;
                border-top: 2px solid #fff;
                border-radius: 50%;
                width: 1.2em;
                height: 1.2em;
                animation: spin 0.8s linear infinite;
                display: inline-block;
                vertical-align: middle;
            }
            @keyframes spin {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
            .participants-title {
                font-weight: 600;
                font-size: 1.1rem;
                margin-bottom: 1rem;
                color: white;
            }
            .participants-grid {
                display: grid;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                gap: 1.25rem 1rem;
                margin-bottom: 1rem;
            }
            @media (max-width: 900px) {
                .participants-grid {
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                }
            }
            @media (max-width: 600px) {
                .participants-grid {
                    grid-template-columns: 1fr;
                }
            }
            .participant-card {
                background: rgba(255, 255, 255, 0.15);
                backdrop-filter: blur(10px);
                border-radius: 1rem;
                border: 1px solid rgba(255, 255, 255, 0.3);
                box-shadow: 0 4px 16px 0 rgba(31, 38, 135, 0.1);
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 1rem 1.25rem;
                transition:
                    box-shadow 0.3s,
                    transform 0.3s,
                    background 0.3s;
                position: relative;
                min-height: 80px;
                opacity: 1;
                transform: scale(1);
                overflow: hidden;
                gap: 1rem;
            }
            .participant-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 3px;
                background: linear-gradient(90deg, #5B8EEE, #4DC8DF);
                border-radius: 1rem 1rem 0 0;
            }
            .participant-card:hover {
                background: rgba(255, 255, 255, 0.25);
                transform: translateY(-2px);
                box-shadow: 0 8px 24px 0 rgba(31, 38, 135, 0.15);
            }
            .participant-card.new {
                animation: fadeInScale 0.7s cubic-bezier(0.4, 2, 0.6, 1) both;
                box-shadow: 0 6px 24px 0 rgba(31, 38, 135, 0.18);
                border: 2px solid #2563eb;
            }
            .participant-card.leave {
                animation: fadeOutScale 0.7s cubic-bezier(0.4, 2, 0.6, 1) both;
                opacity: 0.3;
                pointer-events: none;
            }
            @keyframes fadeInScale {
                0% {
                    opacity: 0;
                    transform: scale(0.7);
                }
                80% {
                    opacity: 1;
                    transform: scale(1.08);
                }
                100% {
                    opacity: 1;
                    transform: scale(1);
                }
            }
            @keyframes fadeOutScale {
                0% {
                    opacity: 1;
                    transform: scale(1);
                }
                100% {
                    opacity: 0;
                    transform: scale(0.7);
                }
            }
            .avatar {
                width: 3rem;
                height: 3rem;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 700;
                font-size: 1.2rem;
                color: #fff;
                background: #64748b;
                user-select: none;
                flex-shrink: 0;
                box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
                border: 3px solid rgba(255, 255, 255, 0.4);
                transition: all 0.3s ease;
                position: relative;
            }
            .avatar::after {
                content: '';
                position: absolute;
                top: -2px;
                left: -2px;
                right: -2px;
                bottom: -2px;
                border-radius: 50%;
                background: linear-gradient(45deg, #5B8EEE, #4DC8DF);
                z-index: -1;
                opacity: 0;
                transition: opacity 0.3s ease;
            }
            .participant-card:hover .avatar::after {
                opacity: 1;
            }
            .participant-card:hover .avatar {
                transform: scale(1.05);
                box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.2);
            }
            .participant-info {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                flex: 1;
                gap: 0.25rem;
            }
            .participant-name {
                font-size: 1.05rem;
                font-weight: 600;
                text-align: left;
                word-break: break-word;
                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
                transition: color 0.3s ease;
                line-height: 1.3;
            }
            .participant-date {
                font-size: 0.8rem;
                font-weight: 400;
                text-align: left;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 10px;
                backdrop-filter: blur(5px);
                transition: all 0.3s ease;
                display: inline-block;
                white-space: nowrap;
            }
            .participant-card:hover .participant-date {
                background: rgba(255, 255, 255, 0.2);
            }
            .loader {
                width: 48px;
                height: 48px;
                border: 5px solid #fff;
                border-bottom-color: #1d4ed8;
                border-radius: 50%;
                display: inline-block;
                box-sizing: border-box;
                animation: rotation 1s linear infinite;
            }

            @keyframes rotation {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
            .results-grid {
                display: flex;
                flex-direction: column;
                gap: 0.75rem;
                margin-bottom: 1rem;
            }
            .result-summary {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                gap: 0.2rem;
                margin-bottom: 1.5rem;
                background: #fef9c3;
                border-radius: 0.75rem;
                padding: 1.2rem 1.25rem 1.1rem 1.25rem;
                border: 1px solid #fde68a;
                box-shadow: 0 2px 8px 0 rgba(251, 191, 36, 0.07);
            }
            .crown-icon {
                font-size: 2.5rem;
                color: #fbbf24;
                margin-bottom: 0.5rem;
                filter: drop-shadow(0 2px 4px rgba(251,191,36,0.15));
            }
            .avg-score-label {
                font-size: 1.1rem;
                font-weight: 600;
                color: #b45309;
                margin-bottom: 0.2rem;
                text-align: center;
            }
            .avg-score-value {
                font-size: 2.2rem;
                font-weight: 800;
                color: #f59e42;
                margin-bottom: 0.2rem;
                background: #fff7ed;
                border-radius: 0.5rem;
                padding: 0.2rem 1.3rem;
                box-shadow: 0 1px 4px 0 rgba(251, 191, 36, 0.06);
                text-align: center;
            }
            .avg-score-congrats {
                font-size: 1rem;
                color: #b45309;
                text-align: center;
            }
            .result-card {
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: #f8fafc;
                border-radius: 0.75rem;
                border: 1px solid #dbeafe;
                box-shadow: 0 2px 8px 0 rgba(31, 38, 135, 0.07);
                padding: 1rem 1.25rem;
                min-height: 70px;
                transition: box-shadow 0.2s, transform 0.2s;
            }
            .result-info {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
            }
            .result-title {
                font-size: 1.05rem;
                font-weight: 600;
                color: #2563eb;
                margin-bottom: 0.15rem;
            }
            .result-category {
                font-size: 0.93rem;
                color: #334155;
                font-weight: 500;
                margin-bottom: 0.1rem;
            }
            .result-date {
                font-size: 0.85rem;
                color: #64748b;
            }
            .score-value {
                font-size: 1.4rem;
                font-weight: 700;
                color: #22c55e;
                background: #e0f7ec;
                border-radius: 0.5rem;
                padding: 0.2rem 1.1rem;
                margin-left: 1.2rem;
                min-width: 60px;
                text-align: center;
                box-shadow: 0 1px 4px 0 rgba(31, 38, 135, 0.06);
            }
            @media (max-width: 600px) {
                .result-card {
                    flex-direction: column;
                    align-items: flex-start;
                    padding: 0.8rem 0.7rem;
                }
                .score-value {
                    margin-left: 0;
                    margin-top: 0.7rem;
                    width: 100%;
                }
            }
            .line-clamp-3 {
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }
            .custom-paginator ::ng-deep .p-paginator {
                background: rgba(255, 255, 255, 0.1);
                border-radius: 1rem;
                padding: 0.5rem;
                backdrop-filter: blur(10px);
            }
            .custom-paginator ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page {
                color: white;
                border-radius: 0.5rem;
                margin: 0 0.25rem;
                transition: all 0.2s;
            }
            .custom-paginator ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page:hover {
                background: rgba(255, 255, 255, 0.2);
            }
            .custom-paginator ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
                background: white;
                color: #5B8EEE;
            }
            .custom-paginator ::ng-deep .p-paginator .p-paginator-first,
            .custom-paginator ::ng-deep .p-paginator .p-paginator-prev,
            .custom-paginator ::ng-deep .p-paginator .p-paginator-next,
            .custom-paginator ::ng-deep .p-paginator .p-paginator-last {
                color: white;
                border-radius: 0.5rem;
                margin: 0 0.25rem;
                transition: all 0.2s;
            }
            .custom-paginator ::ng-deep .p-paginator .p-paginator-first:hover,
            .custom-paginator ::ng-deep .p-paginator .p-paginator-prev:hover,
            .custom-paginator ::ng-deep .p-paginator .p-paginator-next:hover,
            .custom-paginator ::ng-deep .p-paginator .p-paginator-last:hover {
                background: rgba(255, 255, 255, 0.2);
            }
        `
    ],
    template: `
        <div>
            <div class="col-span-12 auth-container">
                <div class="flex justify-center items-center">
                    <div class="auth-card">
                        <div class="auth-title">
                            Gabung Simulasi
                        </div>
                        <div class="flex justify-center">
                            <div>
                                <label class="name-input-label mb-2 pb-2">Masukan kode 6 digit untuk memulai simulasi</label>
                                <div class="otp-input pt-2">
                                    <p-inputotp [(ngModel)]="value" [integerOnly]="true" length="6" size="large" [disabled]="loading || success" required />
                                </div>
                            </div>
                        </div>
                        <div>
                          <div class="name-input-container">
                            <label class="name-input-label">Masukan Nama Anda</label>
                            <input
                              pInputText
                              [(ngModel)]="userName"
                              placeholder="Masukkan nama Anda"
                              class="name-input"
                              [disabled]="loading || success"
                              required
                            />
                          </div>
                          <ng-container *ngIf="success; else joinBtn">
                            <div class="flex justify-center gap-2">
                              <p-button
                                label="Batalkan Gabung Simulasi"
                                styleClass="submit-btn !w-100 p-button-danger"
                                [disabled]="loading"
                                (onClick)="cancelJoinSimulation()"
                                icon="pi pi-times"
                              ></p-button>
                              <p-button
                                label="Masuk Simulasi"
                                (onClick)="router.navigate(['osce/sheet/answer/', this.forms[0].sheet_case_id])"
                                styleClass="submit-btn p-button-success"
                                [disabled]="loading"
                                icon="pi pi-sign-in"
                              ></p-button>
                            </div>
                          </ng-container>
                          <ng-template #joinBtn>
                            <p-button
                              label="Gabung Simulasi"
                              [disabled]="loading || success || !userName || userName.trim().length === 0 || !value || value.length < 6"
                              (onClick)="submitCode()"
                              styleClass="!w-full"
                              [icon]="success ? 'pi pi-check' : 'pi pi-play'"
                            >
                              <ng-template pTemplate="icon">
                                <i *ngIf="loading" class="loading-spinner"></i>
                                <i *ngIf="!loading && !success" class="pi pi-play"></i>
                                <i *ngIf="success" class="pi pi-check"></i>
                              </ng-template>
                            </p-button>
                          </ng-template>
                        </div>
                        <div class="feedback" [ngClass]="{ success: success, error: error }">
                            {{ feedbackMsg }}
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Video Tutorial Simulasi -->
            <div class="col-span-12 mb-8 mt-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100/50 shadow-sm flex flex-col lg:flex-row gap-6 items-center">
                <div class="flex-1">
                    <div class="flex items-center gap-2 mb-3">
                        <span class="bg-blue-500 text-white p-2 rounded-lg flex items-center justify-center">
                            <i class="pi pi-video text-lg"></i>
                        </span>
                        <h3 class="text-xl font-bold text-slate-800">Panduan Video Tutorial</h3>
                    </div>
                    <p class="text-slate-600 mb-4 leading-relaxed">
                        Simak panduan video berikut untuk mempelajari cara menggunakan fitur Simulasi OSCE dan RME dengan mudah dan cepat.
                    </p>
                    <ul class="space-y-2 text-sm text-slate-600">
                        <li class="flex items-center gap-2">
                            <i class="pi pi-check-circle text-green-500 font-bold"></i>
                            Cara memasukkan kode 6 digit simulasi
                        </li>
                        <li class="flex items-center gap-2">
                            <i class="pi pi-check-circle text-green-500 font-bold"></i>
                            Pengisian lembar jawaban OSCE secara real-time
                        </li>
                        <li class="flex items-center gap-2">
                            <i class="pi pi-check-circle text-green-500 font-bold"></i>
                            Melihat hasil skor evaluasi setelah selesai
                        </li>
                    </ul>
                </div>
                <div class="w-full lg:w-1/2 aspect-video rounded-xl overflow-hidden shadow-md bg-black border border-slate-200">
                    <iframe 
                        class="w-full h-full" 
                        src="https://www.youtube.com/embed/1yOzBY3FUFY?si" 
                        title="Tutorial Simulasi OSCE Alopedia" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowfullscreen>
                    </iframe>
                </div>
            </div>

            <!-- Daftar Simulasi -->
            <div class="col-span-12 mb-6 mt-6 flex flex-col md:flex-row md:justify-between md:items-center gap-4">
                <div>
                    <h3 class="text-2xl font-bold flex items-center gap-3">
                        Daftar Simulasi
                    </h3>
                    <p class="mt-2 text-slate-500">Pilih simulasi yang ingin Anda ikuti dari daftar di bawah ini.</p>
                </div>
                <div class="relative w-full md:w-80">
                    <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 z-10"></i>
                    <input 
                        pInputText 
                        type="text" 
                        [(ngModel)]="searchQuery" 
                        (ngModelChange)="onSearchChange()"
                        placeholder="Cari simulasi..." 
                        class="w-full pr-4 py-2 border border-slate-300 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                        style="padding-left: 2.5rem !important;"
                    />
                </div>
            </div>
            
            <div class="col-span-12" *ngIf="!loadingSimulations && allSimulations.length === 0">
                <div class="flex justify-center items-center py-12">
                    <div class="text-center">
                        <i class="pi pi-info-circle text-6xl mb-4 text-slate-300"></i>
                        <div class="font-semibold text-xl mb-2">Tidak ada simulasi tersedia</div>
                        <div class="text-slate-500">Belum ada simulasi yang dibuat. Silakan hubungi administrator untuk membuat simulasi baru.</div>
                    </div>
                </div>
            </div>

            <div class="col-span-12" *ngIf="!loadingSimulations && allSimulations.length > 0 && filteredSimulations.length === 0">
                <div class="flex justify-center items-center py-12">
                    <div class="text-center">
                        <i class="pi pi-search text-6xl mb-4 text-slate-300"></i>
                        <div class="font-semibold text-xl mb-2">Tidak ada simulasi yang cocok</div>
                        <div class="text-slate-500">Cari dengan kata kunci lain atau hapus pencarian Anda.</div>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" *ngIf="!loadingSimulations && filteredSimulations.length > 0">
                <div *ngFor="let sim of paginatedForms; let i = index" class="rounded-2xl flex flex-col h-full group relative overflow-hidden border border-white">
                    <div [ngClass]="getSimulationBgColor(i + currentPage * itemsPerPage)" class="p-4" >
                        <div class="mb-3">
                            <div class="flex items-center gap-2">
                                <i class="pi pi-calendar text-black text-sm"></i>
                                <span class="text-black/90 text-sm font-medium">
                                    {{
                                        sim.start_time
                                            ? (sim.start_time | date:'dd MMM yyyy')
                                            : '03 Jun 2025 00:00'
                                    }}
                                </span>
                            </div>
                        </div>
                        
                        <div class="mb-2">
                            <h3 class="text-black font-bold text-2xl mb-3">{{ sim.name }}</h3>
                            <div class="bg-black/20 text-white font-bold text-md px-3 py-2 rounded-lg w-fit">
                                <i class="pi pi-key text-white me-2"></i>
                                <span class="font-medium">{{ sim.code }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="p-5 bg-white">
                        <div class="text-black/80 text-sm mb-4 flex-1" [innerHTML]="sim.description || 'Tidak ada deskripsi untuk simulasi ini'"></div>
                        
                        <div class="flex flex-wrap gap-2 mb-4">
                            <span class="border border-black text-black text-xs px-3 py-1 rounded flex items-center gap-1">
                                <i class="pi pi-stop-circle"></i>
                                OSCE: {{ sim.osce?.length || 12 }}
                            </span>
                            <span class="border border-black text-black text-xs px-3 py-1 rounded flex items-center gap-1">
                                <i class="pi pi-clock"></i>
                                Durasi: {{
                                    sim.duration ?
                                        (+sim.duration >= 60 ? (+sim.duration / 60) : +sim.duration)
                                        : 15
                                }} Menit
                            </span>
                        </div>
                        
                        <button
                            class="w-full text-white font-bold py-3 px-4 bg-black rounded-xl border-2 border-black transition-all duration-200 flex items-center justify-center gap-2 hover:border-white/80"
                            (click)="goToSimulation(sim.code)">
                            <i class="pi pi-pause"></i>
                            MULAI SIMULASI
                        </button>
                    </div>
                    
                </div>
            </div>
            <div class="flex justify-center mt-8 mb-12" *ngIf="!loadingSimulations && filteredSimulations.length > itemsPerPage">
                <p-paginator 
                    [rows]="itemsPerPage" 
                    [totalRecords]="filteredSimulations.length" 
                    [rowsPerPageOptions]="[6, 12, 18]" 
                    (onPageChange)="onPageChange($event)"
                    styleClass="custom-paginator">
                </p-paginator>
            </div>
            
            <div class="col-span-12 ">
                <div class="flex justify-center items-center" *ngIf="loadingParticipants">
                    <div class="loader-container text-center">
                        <div class="loader"></div>
                        <div class="loader-text font-semibold mt-2">Mohon tunggu, sedang mengambil data peserta</div>
                    </div>
                </div>
                <div class="auth-card-participants auth-container" *ngIf="participants && participants.length > 0">
                    <div *ngIf="participants && participants.length > 0">
                        <div class="participants-title">Peserta</div>
                        <div class="participants-grid" style="grid-template-columns: repeat(4, minmax(0, 1fr));">
                            <div *ngFor="let p of participants" class="participant-card" [ngClass]="{ new: p.isNew, leave: p.isLeaving }">
                                <div class="avatar" [ngStyle]="{ 'background-color': getAvatarColor(p) }">
                                    {{ getInitials(p.name) }}
                                </div>
                                <div class="participant-info">
                                    <span class="participant-name">{{ p.name }}</span>
                                    <span class="participant-date">{{ p.created_at | date: 'short' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-span-12 lg:col-span-6">
                <div class="auth-card-participants" *ngIf="results && results.length > 0">
                    <div>
                        <div class="result-summary">
                            <span class="crown-icon">
                                <i class="pi pi-crown" style="font-size: 3rem"></i>
                            </span>
                            <div class="avg-score-label">
                                Anda telah menyelesaikan simulasi ini. Nilai rata-rata Anda
                            </div>
                            <div class="avg-score-value">
                                {{ getAverageScore() }}
                            </div>
                            <div class="avg-score-congrats">
                                Selamat! Teruslah berlatih untuk meningkatkan nilai Anda.
                            </div>
                        </div>
                        <div class="results-grid">
                            <div *ngFor="let result of results" class="result-card">
                                <div class="result-info">
                                    <div class="result-title">{{ getOsceTitle(result.ID_OSCE) }}</div>
                                    <div class="result-category">{{ result.KATEGORI }}</div>
                                    <div class="result-date">{{ result.CREATED_AT | date: 'medium' }}</div>
                                </div>
                                <div class="score-value">{{ result.SKOR }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="auth-card-participants" *ngIf="results && results.length === 0">
                    <div class="flex flex-col items-center justify-center py-10">
                        <i class="pi pi-info-circle text-4xl text-gray-400 mb-3"></i>
                        <div class="text-gray-500 font-semibold text-lg mb-1">Tidak ada hasil</div>
                        <div class="text-gray-400 text-sm">Anda belum menyelesaikan simulasi atau data hasil belum tersedia.</div>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class Simulation implements OnInit {
    message: string = '';
    messages: any;
    value: string = '';
    loading = false;
    success = false;
    error = false;
    feedbackMsg = '';
    userName: string = '';
    user: any;
    participants: any[] = [];
    loadingParticipants = false;
    loadingSimulations = false;
    forms: any[] = [];
    allSimulations: any[] = [];
    results: any;
    currentParticipant: any;
    currentPage: number = 0;
    itemsPerPage: number = 6;
    searchQuery: string = '';

    get filteredSimulations(): any[] {
        if (!this.searchQuery || this.searchQuery.trim() === '') {
            return this.allSimulations;
        }
        const query = this.searchQuery.toLowerCase().trim();
        return this.allSimulations.filter((sim: any) =>
            (sim.name && sim.name.toLowerCase().includes(query)) ||
            (sim.code && sim.code.toLowerCase().includes(query)) ||
            (sim.description && sim.description.toLowerCase().includes(query))
        );
    }

    get paginatedForms(): any[] {
        const start = this.currentPage * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredSimulations.slice(start, end);
    }

    onSearchChange() {
        this.currentPage = 0;
    }

    private prevParticipantIds: Set<string> = new Set();

    constructor(
        private socketService: SocketService,
        private userService: UserService,
        private router: Router
    ) { }

    ngOnInit(): void {
        const savedValue = localStorage.getItem('simulation_code');
        const savedUserName = localStorage.getItem('simulation_userName');
        const savedFeedbackMsg = localStorage.getItem('simulation_feedbackMsg');
        const savedSuccess = localStorage.getItem('simulation_success');
        const savedError = localStorage.getItem('simulation_error');

        // Tambahan: jika feedbackMsg adalah 'Simulation is running or has finished.', hapus localStorage terkait
        if (savedFeedbackMsg === 'Simulation is running or has finished.') {
            localStorage.removeItem('simulation_code');
            localStorage.removeItem('simulation_userName');
            localStorage.removeItem('simulation_feedbackMsg');
            localStorage.removeItem('simulation_success');
            localStorage.removeItem('simulation_error');
        }

        if (savedValue) this.value = savedValue;
        if (savedUserName) this.userName = savedUserName;
        if (savedFeedbackMsg) this.feedbackMsg = savedFeedbackMsg;
        if (savedSuccess) this.success = savedSuccess === 'true';
        if (savedError) this.error = savedError === 'true';

        // Load all simulations for the list
        this.loadingSimulations = true;
        this.userService.getPackageSimulation().then((res) => {
            if (res && res.data) {
                this.allSimulations = res.data.map((form: any) => {
                    try {
                        form.osce = typeof form.osce_id === 'string' ? JSON.parse(form.osce_id) : [];
                    } catch {
                        form.osce = [];
                    }
                    return form;
                });
            }
            this.loadingSimulations = false;
        }).catch(() => {
            this.loadingSimulations = false;
        });

        if (savedValue) {
            this.userService.getPackageSimulation().then((res) => {
                this.forms = res.data;

                const val = (this.value + '').trim();
                this.forms = this.forms.filter((form: any) => (form.code + '').trim() === val);

                this.forms = this.forms.map((form: any) => {
                    try {
                        form.osce = typeof form.osce_id === 'string' ? JSON.parse(form.osce_id) : [];
                    } catch {
                        form.osce = [];
                    }
                    return form;
                });
            });
        }

        this.socketService.listen('receive-message').subscribe((data: any) => {
            this.messages = data;
            if (this.messages.code == this.value) {
                if (this.messages.status == 'start') {
                    this.router.navigate([`osce/sheet/answer/`, this.forms[0].sheet_case_id]);
                }
                if (this.messages.status == 'waiting') {
                    this.getParticipant();
                } else {
                }
            }
        });

        const userLogin = localStorage.getItem('user');
        if (userLogin) {
            this.user = JSON.parse(userLogin);
        }

        if (this.value && this.userName) {
            // Cek simulation_error sebelum getParticipant
            const simulationError = localStorage.getItem('simulation_error');
            if (simulationError !== 'true') {
                this.getParticipant();
            }
        }
    }

    submitCode() {
        console.log("simulation start");

        if (!this.value || this.value.length < 6) {
            this.error = true;
            this.feedbackMsg = 'Silakan masukkan kode 6 digit dengan lengkap.';
            localStorage.setItem('simulation_feedbackMsg', this.feedbackMsg);
            localStorage.setItem('simulation_error', 'true');
            return;
        }
        this.loading = true;
        this.joinSimulation()
            .then(() => {
                this.error = false;
                this.success = true; // <-- Perbaikan di sini, set success ke true
                this.feedbackMsg = '';
                localStorage.setItem('simulation_code', this.value);
                localStorage.setItem('simulation_userName', this.userName);
                localStorage.setItem('simulation_feedbackMsg', this.feedbackMsg);
                localStorage.setItem('simulation_success', this.success.toString());
                localStorage.setItem('simulation_error', this.error.toString());
            })
            .catch(() => {
                this.loading = false;
            });
    }

    async joinSimulation(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            try {
                const payload = {
                    user_id: this.user.ID_USER,
                    name: this.userName,
                    code: this.value
                };
                this.userService
                    .simulationJoin(payload)
                    .then((response) => {
                        if (response && response.status) {
                            this.success = true;
                            this.feedbackMsg = response && response.message ? response.message : 'Anda berhasil bergabung ke simulasi.';
                            localStorage.setItem('simulation_code', this.value);
                            localStorage.setItem('simulation_userName', this.userName);
                            localStorage.setItem('simulation_feedbackMsg', this.feedbackMsg);
                            localStorage.setItem('simulation_success', 'true');
                            localStorage.setItem('simulation_error', 'false');
                            this.send();
                            // Cek simulation_error sebelum getParticipant
                            const simulationError = localStorage.getItem('simulation_error');
                            if (simulationError !== 'true') {
                                this.getParticipant();
                            }
                            this.loading = false;
                            resolve();
                        } else {
                            this.error = true;
                            this.feedbackMsg = response && response.message ? response.message : 'Kode tidak valid. Silakan coba lagi.';
                            localStorage.setItem('simulation_feedbackMsg', this.feedbackMsg);
                            localStorage.setItem('simulation_success', 'false');
                            localStorage.setItem('simulation_error', 'true');
                            this.loading = false;
                            reject();
                        }
                        this.userService.getPackageSimulation().then((res) => {
                            this.forms = res.data;
                            this.forms = this.forms.filter((form) => form.code === this.value);
                            this.forms = this.forms.map((form) => {
                                form.osce = JSON.parse(form.osce_id);
                                return form;
                            });
                        });
                    })
                    .catch((error) => {
                        this.error = true;
                        this.feedbackMsg = this.error ? (error.error && error.error.message ? error.error.message : 'Terjadi kesalahan. Silakan coba lagi.') : 'Terjadi kesalahan. Silakan coba lagi.';
                        this.loading = false;
                        this.userService.getPackageSimulation().then((res) => {
                            this.forms = res.data;
                            this.forms = this.forms.filter((form) => form.code === this.value);
                            this.forms = this.forms.map((form) => {
                                form.osce = JSON.parse(form.osce_id);
                                return form;
                            });

                            if (this.forms.length > 0 && this.forms[0].status == 'finished') {
                                if (
                                    error.error &&
                                    error.error.message == 'Simulation is running or has finished.'
                                ) {
                                    this.userService.simulationUserAnswer({ user_id: this.user.ID_USER, package_id: this.forms[0].id }).then((res) => {
                                        this.results = res.data;
                                    })
                                }
                            }
                        });

                        reject();
                    });
            } catch (error) {
                this.error = true;
                this.feedbackMsg = 'Terjadi kesalahan. Silakan coba lagi.';
                this.loading = false;
                reject();
            }
        });
    }

    getParticipant(): Promise<any> {
        this.loadingParticipants = true;
        const payload = {
            code: this.value
        };
        return this.userService
            .simulationParticipant(payload)
            .then((response) => {
                const oldIds = new Set(this.participants.map((p) => p.id));
                const newIds = response.data.map((p: any) => p.id);
                const prevIds = this.participants.map((p) => p.id);
                this.currentParticipant = response.data.find((p: any) => p.user_id === this.user.ID_USER);

                if (this.currentParticipant) {
                    localStorage.setItem('simulation_currentParticipant', JSON.stringify(this.currentParticipant));
                }

                const leaving = this.participants.filter((p) => !newIds.includes(p.id)).map((p) => ({ ...p, isLeaving: true }));

                const newList = response.data.map((p: any) => {
                    return {
                        ...p,
                        isNew: !oldIds.has(p.id),
                        isLeaving: false
                    };
                });

                this.participants = [...newList, ...leaving];

                if (leaving.length > 0) {
                    setTimeout(() => {
                        this.participants = this.participants.filter((p) => !p.isLeaving);
                    }, 700);
                }

                setTimeout(() => {
                    this.participants = this.participants.map((p) => ({ ...p, isNew: false }));
                }, 1500);

                this.prevParticipantIds = new Set(this.participants.map((p) => p.id));
                this.loadingParticipants = false;
            })
            .catch((error) => {
                this.error = true;
                this.feedbackMsg = this.error ? (error.error && error.error.message ? error.error.message : 'Terjadi kesalahan. Silakan coba lagi.') : 'Terjadi kesalahan. Silakan coba lagi.';
                localStorage.setItem('simulation_feedbackMsg', this.feedbackMsg);
                localStorage.setItem('simulation_success', 'false');
                localStorage.setItem('simulation_error', 'true');
                this.loadingParticipants = false;
            });
    }

    send(): void {
        const message = {
            code: this.value,
            status: 'waiting',
            message: 'New participant: ' + this.userName
        };
        this.socketService.emit('send-message', message);
        this.message = '';
    }

    getInitials(name: string): string {
        if (!name) return '';
        const words = name.trim().split(' ');
        if (words.length === 1) {
            return words[0].substring(0, 2).toUpperCase();
        }
        return (words[0][0] + words[1][0]).toUpperCase();
    }

    getAvatarColor(p: any): string {
        const colors = ['#2563eb', '#f59e42', '#10b981', '#e11d48', '#a21caf', '#64748b', '#fbbf24', '#0ea5e9'];
        let hash = 0;
        const str = p.user_id || p.name || '';
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        const idx = Math.abs(hash) % colors.length;
        return colors[idx];
    }

    cancelJoinSimulation() {
        const data = {
            user_id: this.user.ID_USER,
            code: this.value,
            name: this.userName
        };
        this.userService
            .simulationDelete(data)
            .then((response) => {
                this.send();
                this.success = false;
                this.value = '';
                this.userName = '';
                this.feedbackMsg = '';
                this.participants = [];
                this.loadingParticipants = false;
                this.forms = []; // <-- clear Detail Simulasi

                localStorage.removeItem('simulation_code');
                localStorage.removeItem('simulation_userName');
                localStorage.removeItem('simulation_feedbackMsg');
                localStorage.removeItem('simulation_success');
                localStorage.removeItem('simulation_error');
            })
            .catch((error) => {
                this.error = true;
                this.feedbackMsg = this.error ? (error.error && error.error.message ? error.error.message : 'Terjadi kesalahan. Silakan coba lagi.') : 'Terjadi kesalahan. Silakan coba lagi.';
                localStorage.setItem('simulation_feedbackMsg', this.feedbackMsg);
                localStorage.setItem('simulation_success', 'false');
                localStorage.setItem('simulation_error', 'true');
                this.loadingParticipants = false;
            });
    }

    // Tambahkan method untuk mendapatkan judul OSCE
    getOsceTitle(osceId: string): string {
        if (!this.forms || this.forms.length === 0 || !this.forms[0].osce) return 'OSCE tidak diketahui';
        const osce = this.forms[0].osce.find((o: any) => o.ID_OSCE === osceId);
        return osce && osce.TITLE ? osce.TITLE : 'OSCE tidak diketahui';
    }

    getAverageScore(): number {
        if (!this.results || !Array.isArray(this.results) || this.results.length === 0) return 0;
        const total = this.results.reduce((sum: number, r: any) => sum + (parseFloat(r.SKOR) || 0), 0);
        return Math.round((total / this.results.length) * 100) / 100;
    }

    onPageChange(event: any) {
        this.currentPage = event.page;
    }

    getSimulationBgColor(i: number): string {
        const colors = [
            'bg-[#DBEDFA]',
            'bg-[#F3DFE3]',
            'bg-[#E1F6E9]'
        ];
        return colors[i % colors.length];
    }

    getSimulationButtonColor(i: number): string {
        const colors = [
            'bg-[#52978C] hover:bg-[#52978C]/90',
            'bg-[#3B5A7C] hover:bg-[#3B5A7C]/90',
            'bg-[#A8103F] hover:bg-[#A8103F]/90'
        ];
        return colors[i % colors.length];
    }

    goToSimulation(code: string) {
        this.value = code;
        localStorage.setItem('simulation_code', code);
        this.router.navigate(['/app/osce/simulation']);
    }
}
